import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  makeTitle: {
    defaultMessage: 'MAKE',
    id: 'bXCiK6',
    description: 'MAKE field title (vehicle info)',
  },
  modelTitle: {
    defaultMessage: 'MODEL',
    id: 'kgzpAd',
    description: 'MODEL field title (vehicle info)',
  },
  engineTitle: {
    defaultMessage: 'Engine',
    id: 'global_vehicle_info_engine',
    description: 'Engine field title',
  },
  generationTitle: {
    defaultMessage: 'Generation',
    id: 'Xnyjxj',
    description: 'Vehicle form: Generation field title',
  },
  yearTitle: {
    defaultMessage: 'YEAR',
    id: 'GJizmK',
    description: 'vehicle form input title',
  },
  colorTitle: {
    defaultMessage: 'VEHICLE COLOUR',
    id: 'q0A0Yx',
    description: 'VEHICLE COLOUR field title',
  },
  interiorColorTitle: {
    defaultMessage: 'INTERIOR COLOUR',
    id: '1Udahz',
    description: 'INTERIOR COLOUR field title',
  },
  wheelbaseTitle: {
    defaultMessage: 'Wheelbase',
    id: '58jrmh',
    description: 'Wheelbase field title',
  },
  wheelbaseDescription: {
    defaultMessage:
      'You can find this information in your logbook under "Model". For example, S580 L is a Long.',
    id: 't2mugL',
    description: 'Wheelbase field description',
  },
  registrationDateTitle: {
    defaultMessage: 'DATE OF FIRST REGISTRATION',
    id: 'J7FGJZ',
    description: 'DATE OF FIRST REGISTRATION field title',
  },
  registrationDateNotInFuture: {
    defaultMessage: 'Date cannot be in the future.',
    id: 'pLBW9Q',
    description: 'Car registration date error message',
  },
  licensePlateTitle: {
    defaultMessage: 'LICENSE PLATE',
    id: '+fhe3u',
    description: 'LICENSE PLATE field title',
  },
  licensePlatePlaceholder: {
    defaultMessage: 'AA00AAA',
    id: 'SVUpUP',
    description: 'LICENSE PLATE field placeholder',
  },
  licensePlateDescription: {
    defaultMessage: 'Please enter the license plate without spaces and additional characters',
    id: 'onboarding_vehicle_info_licens_plate_description',
    description: 'Vehicle form - license plate field description',
  },
  vinTitle: {
    defaultMessage: 'VIN',
    id: 'MRWmN/',
    description: 'VIN field title',
  },
  vinUsLength17: {
    defaultMessage: 'VIN must be 17 characters.',
    id: 'onboarding_vehicle_info_vin_us_length_17',
    description: 'Vehicle form - VIN validation for US (17 chars)',
  },
  tlcVehicleLicense: {
    defaultMessage: 'TLC Vehicle License Number',
    id: 'tlc_vehicle_license_number_title',
    description: 'US TLC Vehicle License Number field title',
  },
  tlcVehicleLicenseError: {
    defaultMessage: 'License Number must be 7 digits.',
    id: 'tlc_vehicle_license_number_error',
    description: 'TLC Vehicle License Number validation message',
  },
  addDocumentsTitle: {
    defaultMessage: 'ADD DOCUMENTS',
    id: 'pytlFK',
    description: 'Docs list title',
  },
  nextButtonText: {
    defaultMessage: 'NEXT',
    id: '6jg2Fp',
    description: 'OnBoarding next button text',
  },
});
